import { VisibilityOutlined, Anchor, Business, Email, Person } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { useNavigation } from "@refinedev/core";
import { useDataGrid } from "@refinedev/mui";
import { RefineListView } from "../../components/refine-list-view";
import { UsersIcon } from "../../components/icons/users-icon";
import { useSingleFieldSearch } from "../../hooks/useSingleFieldSearch";
import { AdminUserDto } from "../../types/models/AdminUserDto";

export const ListUsers = () => {
  const { dataGridProps, setFilters } = useDataGrid<AdminUserDto>({
    syncWithLocation: true,
    filters: { mode: "server" },
    sorters: { mode: "server" },
    pagination: { mode: "server", pageSize: 10 },
    resource: "AdminUsers",
  });

  const columns: GridColDef<AdminUserDto>[] = [
    { field: "id", headerName: "ID", minWidth: 90, flex: 1 },
    {
      field: "vesselImo",
      headerName: "IMO",
      minWidth: 100,
      flex: 1,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Anchor fontSize="small" />
          IMO
        </Box>
      ),
    },
    {
      field: "vesselOwner",
      headerName: "Vessel Owner",
      minWidth: 300,
      flex: 1,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Business fontSize="small" />
          Vessel Owner
        </Box>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 300,
      flex: 1,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Email fontSize="small" />
          Email
        </Box>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      minWidth: 150,
      flex: 1,
      renderHeader: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Person fontSize="small" />
          Username
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      hideable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      minWidth: 80,
      renderCell: function render({ row }) {
        return (
          <IconButton
            sx={{
              cursor: "pointer",
            }}
            onClick={() => edit("users", row.id)}
          >
            <VisibilityOutlined color="action" />
          </IconButton>
        );
      },
    },
  ];

  const { searchValues, handleInputChange } = useSingleFieldSearch(
    {
      vesselImo: "",
      vesselOwner: "",
      email: "",
      username: "",
    },
    setFilters
  );

  const { edit } = useNavigation();

  const title = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <UsersIcon color="primary" />
      <Typography variant="h6">Users</Typography>
    </Box>
  );

  return (
    <RefineListView title={title}>
      <Box mb={2}>
        <Stack direction="row" spacing={2} flexWrap="wrap">
          <TextField
            label="Vessel IMO"
            value={searchValues.vesselImo}
            onChange={handleInputChange("vesselImo")}
            size="small"
          />
          <TextField
            label="Vessel Owner"
            value={searchValues.vesselOwner}
            onChange={handleInputChange("vesselOwner")}
            size="small"
          />
          <TextField
            label="Email"
            value={searchValues.email}
            onChange={handleInputChange("email")}
            size="small"
          />
          <TextField
            label="Username"
            value={searchValues.username}
            onChange={handleInputChange("username")}
            size="small"
          />
        </Stack>
      </Box>
      <DataGrid
        {...dataGridProps}
        /*onFilterModelChange={(c) => {
          console.log(c);

          setFilters([
            {
              field: "email" as string,
              operator: "contains",
              value: c.quickFilterValues[0],
            },
            {
              field:  as string,
              operator: "contains",
              value: c.quickFilterValues[0],
            },
          ]);

          // dataGridProps.onFilterModelChange(c);
        }}*/
        columns={columns}
        pageSizeOptions={[5, 10, 25, 50]}
        initialState={{
          density: "standard",
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: false,
          },
        }}
        disableDensitySelector
        onRowClick={({ id }) => {
          edit("users", id);
        }}
        sx={{
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
        }}
      />
    </RefineListView>
  );
};
